// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedTilesFixedFixedV1_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13 0H24V2L15 2V11H13V0ZM11 13V15L2 15V24H0V13L11 13Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 0H32V2L19 2V15H17V0ZM0 17H15V19H2V32H0V17Z" class="svg-bg"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21 19V0H40V2L23 2V19H21ZM0 21V40H2V23L19 23V21H0Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedTilesFixedFixedV1 is a generated icon component.
 */
let IconMedTilesFixedFixedV1 = IconMedTilesFixedFixedV1_1 = class IconMedTilesFixedFixedV1 extends IconBaseElement {
    render() {
        return html `${IconMedTilesFixedFixedV1_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedTilesFixedFixedV1.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s40IconSvg],
    ['s64', _s40IconSvg],
    ['s72', _s40IconSvg],
    ['s80', _s40IconSvg],
]);
IconMedTilesFixedFixedV1 = IconMedTilesFixedFixedV1_1 = __decorate([
    customElement('zui-icon-med-tiles-fixed-fixed-v-1')
], IconMedTilesFixedFixedV1);
export { IconMedTilesFixedFixedV1 };
